<template>
	<div v-if="data" class="invite_wrap">
		<div class="basic_wrap">
			<div class="top_header">
				<div class="user_detail">
					<div class="user_header">
						<img src="../images/shop/head.png" alt="">
					</div>
					<div class="user_name">
						<div class="user_all" style="font-size: 14px;font-weight: 600;line-height: 30px;display: flex;align-items: center;">
							<p style="margin-left: 1em;margin-right: 5px;">{{user.name}}</p>
							<van-icon :name="vip.img" size="25" />
						</div>
						<div class="user_all" v-if="user">
							<p style="font-size: 12px;line-height: 23px;margin-left: 1em;font-weight: bold;">
								{{$t('d.creditscore')}}: 
								<van-progress stroke-width="6" color="#f1bb0e" :percentage="user.integral" style="display: inline-block;width: 100px;"/>
							</p>
						</div>
					</div>
					<div class="msg" @click="$router.push('/notice')">
						<van-icon v-if="tong&&tong.unreadnum>0" name="smile-comment" size="30" color="#000" :badge="tong.unreadnum"/>
						<van-icon v-if="tong&&tong.unreadnum==0" name="smile-comment" size="30" color="#000"/>
					</div>
				</div>
				
				<div class="cards">
				    <div  class="top flex-b-s">
				        <div  class="top-left">
				            <div >{{$t('e.walletaccount')}}</div>
				            <div >{{1*data.money}}<span >{{$t('e.usdc')}}</span></div>
				        </div>
				        <div  class="top-right"></div>
				    </div>
				    <div  class="middle">
				        <span @click="mtab=1" :class="mtab==1?'mActive':''">{{$t('e.TodaysEarnings')}}</span>
				        <span @click="mtab=2" :class="mtab==2?'mActive':''">{{$t('e.TotalEarnings')}}</span>
				    </div>
				    <div  class="bottom flex-b-c" v-if="tong">
				        <div v-if="mtab==1" class="bottom-left flex-e-s">
				            <div  class="left-item">
				                <div >{{$t('e.OrderRevenue')}}</div>
				                <div >{{tong.tfee}}</div>
				            </div>
				            <div  class="left-item">
				                <div >{{$t('home.team')}}</div>
				                <div >{{tong.tteamfee}}</div>
				            </div>
				            <div  class="left-item">
				                <div >{{$t('e.TotalEarnings')}}</div>
				                <div >{{tong.tfee + tong.tteamfee}}</div>
				            </div>
				        </div>
				        <div v-if="mtab==2" class="bottom-left flex-e-s">
				            <div  class="left-item">
				                <div >{{$t('e.OrderRevenue')}}</div>
				                <div >{{tong.allfee}}</div>
				            </div>
				            <div  class="left-item">
				                <div >{{$t('home.team')}}</div>
				                <div >{{tong.allteamfee}}</div>
				            </div>
				            <div  class="left-item">
				                <div >{{$t('e.TotalEarnings')}}</div>
				                <div >{{tong.allfee + tong.allteamfee}}</div>
				            </div>
				        </div>
				    </div>
				</div>
				
				<div  class="con">
					<div  class="cardd flex-b-c">
					    <div  class="cardd-item flex-c-c" @click="$router.push('/about/44')">
					        <img  src="../images/shop/g1.png"  alt="">
					        <span >{{$t('e.OrderDescription')}}</span>
					    </div>
					    <div  class="cardd-item flex-c-c" @click="$router.push('/about/42')">
					        <img  src="../images/shop/g2.png" alt="">
					        <span >{{$t('e.PleaseNote')}}</span>
					    </div>
					</div>
					<div class="vip-box" v-if="vip" @click="$router.push('/vip')">
					    <div class="VipLevel flex-b-c">
					        <div class="left flex-b-c">
								<van-icon  :name="vip.img"  size="25" />
					            <span class="level">{{vip.name}}</span>
					        </div>
					        <div class="right flex-b-c">
					            <span class="clickToEnte">Comm x {{vip.rate}}%</span>
					            <van-icon name="arrow" size="14" />
					        </div>
					    </div>
					</div>
					<div  class="start-box">
					    <img  src="../images/shop/gap.gif" class="img">
					</div>
					<div class="btn-box">
						<button class="btn" @click.stop="grap()">
						   {{$t('shopd.graporder')}}
						   （{{user.ono}}/{{user.onum}}）
						</button>
					</div>
				</div>
			</div>
			<!-- <div class="top van-row shadow">
			    <div class="shop van-col van-col--24">
					<div class="van-row van-row--flex van-row--align-center van-row--justify-space-between"  >
					    <div class="van-col van-col--24">
					        <div class="current van-row">
					            <div class="van-col van-col--24">{{utils_moneyMark()}} {{1*data.money}}</div>
					            <div class="van-col van-col--24">{{$t('invest.availableBalance')}}</div>
					        </div>
					    </div>
					    <div class="van-col">
					        <van-icon @click="$router.push('/invest')" name="add" style="border-radius: 50px !important;" color="#ffcd00" class="shadow" size="50px"/>
					    </div>
					</div>
			    </div>
			    <div class="balance van-col van-col--24">
			        
			        <div
			             class="other van-row van-row--flex van-row--align-center van-row--justify-space-between">
			            <div class="van-col">
			                <div>{{utils_moneyMark()}} {{tong.tfee}}</div>
			                <div>{{$t('shopd.todaycomission')}}</div>
			            </div>
			            <div class="van-col">
			                <div>{{utils_moneyMark()}} {{tong.allfee}}</div>
			                <div>{{$t('shopd.totalcomission')}}</div>
			            </div>
			        </div>
			        <div class="other van-row van-row--flex van-row--align-center van-row--justify-space-between">
			            <div class="van-col">
			                <div>{{tong.frezzenum}}</div>
			                <div>{{$t('c3.frezeenum')}}</div>
			            </div>
			            <div class="van-col">
			                <div>{{utils_moneyMark()}} {{tong.frezze}}</div>
			                <div>{{$t('c3.frezeeamount')}}</div>
			            </div>
			        </div>
			        <div class="other van-row van-row--flex van-row--align-center van-row--justify-space-between">
			            <div class="van-col">
			                <div>{{tong.tnum}}</div>
			                <div>{{$t('shopd.todaycorder')}}</div>
			            </div>
			            <div class="van-col">
			                <div>{{tong.anum}}</div>
			                <div>{{$t('shopd.todayuncorder')}}</div>
			            </div>
			        </div>
			        <div class="grab-button van-row van-row--flex">
			            <div class="van-col van-col--24">
			                <button class="van-button van-button--primary van-button--large shadow" @click="grap()">
			                    <div class="van-button__content">
			                        <span class="van-button__text">{{$t('shopd.graporder')}}</span>
			                    </div>
			                </button>
			            </div>
			        </div>
			    </div>
			</div> -->
				
	<!-- 		<div class="notice_content " v-if="cashes && cashes.length > 0" style="padding-left:3%;display: flex;height: 30px; overflow: hidden;margin:15px auto;">
				<van-icon name="volume-o" size="25"/>
				<van-swipe style="height: 30px;padding-left: 5%;" :show-indicators="false" autoplay="1500"  :vertical="true">
				  <van-swipe-item heig  v-for="i in cashes" style="display: flex;line-height: 30px;" :key="i.id">
					 <div v-html="i.text"></div>
				  </van-swipe-item>
				</van-swipe>
			</div> -->
			
			<!-- <div class="user_top1 ">
				<div class="introduce">
					<div class="line left_line"></div>
					<div class="tit">{{$t('c3.desct')}}</div>
					<div class="line right_line"></div>
				</div>
			   <div class="award_tip">
					<p>{{$t('c3.desc')}}</p>
			   </div>
			</div> -->
			<!-- <div class="user_money">
				<div class="money_num">
					<div>
						<p style="font-weight: bold; font-size: 17px; margin: 0px 5px;">
							$ {{money}} 
						</p>
					</div>
					<div style="font-size:1.3em;font-weight: bold;">{{$t('invest.availableBalance')}}</div>
				</div>
				<div class="user_but">
					<div class="but_click but1" @click="$router.push('/cash')">
					{{$t('user.withdraw')}}
					</div>
					<div class="but_click but2" @click="$router.push('/invest')">
					{{$t('moneybag.recharge')}}
					</div>
				</div>
			</div>
			<div class="capital_title">
			    <div class="capital_text">
					<img src="../images/shop2/shop_img.png" draggable="true" style="border-radius: 5px;width: 100%;"/>
				</div>
			    <div class="capital_fun">
			        <div><p>{{$t('shopds.tasksnum')}}</p>
			            <p>{{tong.anum}}</p></div>
			        <div><p>{{$t('shopds.qcompleted')}}</p>
			            <p>{{tong.tnum}}</p></div>
			    </div>
			    <div class="nopermit">
			    	<div class="basic_btn" @click="grap()" >{{$t('shopd.graporder')}}</div>
			    </div>
			    <div class="capital_result">
					<div>
					   <img src="../images/home/shouyi2.png" alt="">
					    <p>{{$t('shopds.dayincome')}}:</p>
					    <p style="color: rgb(255, 83, 83);">$ {{tong.tfee}} </p></div>
			        <div>
						<img src="../images/home/shouyi3.png" alt="">
			            <p>{{$t('shopds.allimcome')}}:</p>
			            <p style="color: rgb(255, 83, 83);">$ {{tong.allfee}} </p></div>
			    </div>
			</div> -->
			<van-overlay :show="show3" @click="show3 = false;show=true;">
			  <div class="wrapper1">
				<img src="../images/shop2/cog.png" style="width: 90vw;position: fixed;left: 5%;top: 20vh;" >
			  </div>
			</van-overlay>
			
			<van-overlay :show="show1" @click="show1 = false" >
			  <div class="wrapper1" @click.stop style="height: 100vh;100vw;">
				  <div class="block">
					<van-circle
					  v-model:current-rate="currentRate"
					  :stroke-width="60"
					  rate="0"
					  size="100%"
					  :color="gradientColor"
					  :text="$t('shopd.graping')"
					/>
				</div>
			  </div>
			</van-overlay>
			
			<van-overlay :show="show" @click="show = false">
			  <div class="wrapper" @click.stop>
			    <div class="pop_box" v-if="order">
			        <div class="order_cards" >
			            <div  class="order_list1" >
			                <div  class="list_top1">
			                    <img :src="order.pic">
			                    <div  class="list_text1">
			                        <span>{{order.title}}</span>
			                        <div>
			                            <p >{{order.price}}</p>
			                            <p >X1</p>
			                        </div>
			                    </div>
			                </div>
			                <div  class="list_down1">
			                    <div  class="list_down">
			            			<div >
			            			    <span>{{$t('shopds.onum')}}</span>
			            			    <span>{{order.no}}</span>
			            			</div>
			                        <div >
			                            <span v-if="order.preuid==0">{{$t('shopds.money')}}</span>
			                            <span v-else>{{$t('e.luckyprice')}}</span>
			                            <span>{{order.price}}</span>
			                        </div>
									<div v-if="(1*data.user.money)<0">
									    <span>{{$t('shopds.needba')}}</span>
									    <span>{{(1*data.user.money).toFixed(0)}}</span>
									</div>
									<div>
									    <span v-if="order.preuid==0">{{$t('e.rate')}}</span>
									     <span v-else>{{$t('e.luckyrate')}}</span>
										<span style="color: rgb(255, 83, 83);">{{(100*order.rate).toFixed(2)}} %</span>
									</div>
									<div>
									    <span v-if="order.preuid==0">{{$t('shopds.income')}}</span>
									     <span v-else>{{$t('e.luckyincome')}}</span>
										<span style="color: rgb(255, 83, 83);">{{order.fee}}</span>
									</div>
			                        
			                        <div >
			                            <span>{{$t('shopds.numtask')}}</span>
			                            <span>{{order.level}}</span>
			                        </div>
			                        <!-- <div >
			                            <span>{{$t('shopds.time')}}</span>
			                            <span>{{order.ct}}</span>
			                        </div> -->
			                    </div>
			                </div>
			            </div>
			        </div>
			    	<div class="capital_evaluate">
			    		<span>{{$t('shopds.score')}}</span>
			    		<van-rate v-model="star" clearable />
						<span v-if="conf"><img src="../images/shop2/cog.png" style="height: 5vh;margin-left: 5%;" ></span>
			    	</div>
			    	<div class="pop_but"  @click="doorder()">
			    	    <span><span>{{$t('shopds.deal')}}</span></span>
			    	</div>
			    	<div class="pop_but second" @click="show = false">
			    	    <span><span>{{$t('shopd.cancelbtn')}}</span></span>
			    	</div>
			    </div>
			  </div>
			</van-overlay>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Progress,
		Swipe,
		SwipeItem,
		Empty,
		Button,
		Dialog,
		Toast,
		Overlay,
		Circle,
		Icon,Rate
	} from 'vant';
	import Clipboard from "v-clipboard";
	// import { random } from 'core-js/fn/number';
	Vue.use(Empty)
	.use(Progress)
	.use(Toast)
	.use(Button)
	.use(Clipboard)
	.use(Icon)
	.use(Dialog).use(Overlay).use(Circle).use(Rate);
	
	export default {
		name: "grap",
		data() {
			return {
				mtab:1,
				money:0,
				show1:false,
				conf:false,
				data:null,
				user:null,
				tong:null,
				cashes:null,
				order:null,
				show3:false,
				submiting:false,
				show:false,
				star:0,
				currentRate:0,
				gradientColor:{
					'0%': '#FFF500',
					'100%': '#FF00B8'
				},
				vip:null,
				vips:null
			};
		},
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
			bsHeader
		},
		created() {
			this.$parent.footer('grap');
		},
		
		mounted() {
			this.start();
		},
		methods: {
			
			doorder(){
				if(this.star<3){
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopds.lowscore')
					});
					return false;
				}
				var t = Math.floor(Math.random() * 1000) + 300;
				Toast.loading({
					duration:t,
					forbidClick: true,
					className:'toastc',
					loadingType: 'spinner',
					message: this.$t('d.grap1')
				});
				setTimeout(()=>{
					t = Math.floor(Math.random() * 1000) + 300;
					Toast.loading({
						duration:t,
						forbidClick: true,
						className:'toastc',
						loadingType: 'spinner',
						message: this.$t('d.grap2')
					 });
					setTimeout(()=>{
						t = Math.floor(Math.random() * 1000) + 300;
						Toast.loading({
							duration:t,
							forbidClick: true,
							className:'toastc',
							loadingType: 'spinner',
							message: this.$t('d.grap3')
						});
						setTimeout(()=>{
						  this.dosuborder();
						},t);
					},t);
				},t);
				
			},
			dosuborder(){
				Fetch("/user/doorder", {
				  id: this.order.id
				}).then(r => {
					this.show = false;
					if(r && r.code==1 && r.data && r.data.islucky){
						this.order=r.data;
						this.star=0;
						this.money = (r.data.money-r.data.price).toFixed(0);
						// showDialog({
						//   message: this.$t('shopd.lorder'),
						//   theme: 'round-button',
						// }).then(() => {
						//   this.$router.push('/ordering');
						// });
						if(this.order['islucky']){
							this.$toast({
								duration:'5000',
								background: '#07c160',
								message: this.$t('shopd.lorder')
							});
							this.conf =true;
							this.show3=true;
						}else{
							this.show=true;
						}
					}else{
						this.$toast({
							duration:'2000',
							background: '#07c160',
							message: this.$t('shopd.corder')
						});
					}
					
					this.start();
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							className:"dialogstyle",
							title: 'Tips',
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('shopds.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(0)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
					}
				})
			},
			grapdata(){
				setTimeout(() => {
					this.submiting = false;
				}, 5000);
				Fetch('/user/grap').then((r) => {
					this.submiting = false;
					// if(r.data=='noaddress'){
					// 	this.$toast({
					// 		background: '#07c160',
					// 		message: this.$t('shopd.setaddr')
					// 	});
					// 	this.$router.push('/addr');
					// }else{
						if(r.data){
							
							this.order=r.data;
							this.star=0;
							this.money = (r.data.money-r.data.price).toFixed(0);
							// showDialog({
							//   message: this.$t('shopd.lorder'),
							//   theme: 'round-button',
							// }).then(() => {
							//   this.$router.push('/ordering');
							// });
							if(this.order['islucky']){
								this.$toast({
									duration:'5000',
									background: '#07c160',
									message: this.$t('shopd.lorder')
								});
								this.conf =true;
								this.show3=true;
							}else{
								this.show=true;
							}
							
							// this.$router.push('/ordering');
						}else{
							this.$router.push('/ordering');
						}
					// }
				});
			},
			grap(){
				if(this.show1||this.submiting){
					return false;
				}
				this.submiting = true;
				this.show1 = true;
				this.conf = false;
				var randomInt = Math.floor(Math.random() * 50) + 20;
				this.currentRate = 0;
				this.graptime(randomInt);
				// this.startSlotMachine();
				// this.grapdata();
			},
			graptime(randomInt){
				this.currentRate += randomInt;
				if(this.currentRate<100){
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				}else{
					this.show1 = false;
					this.grapdata();
				}
			},
			upvip(it){
				this.$router.push('/invest');
				// if(this.vip){
				// 	if(this.vip.no < it.no){
				// 		Dialog.confirm({
				// 			title: this.$t('shopd.suretitle'),
				// 			confirmButtonText: this.$t('shopd.surebtn'),
				// 			cancelButtonText: this.$t('shopd.cancelbtn'),
				// 			message: this.$t('shopd.surec1')+it.price+ this.$t('shopd.surec2')+it.no+'?'
				// 		}).then(() => {
				// 		    Fetch('/user/upvip', {
				// 		      vip: it.id
				// 		    }).then((r) => {
				// 				if(r.code==1){
				// 					this.$router.push('/user');
				// 				}else{
				// 					this.$router.push('/invest');
				// 				}
				// 		    });
				// 		}).catch(() => {
						    
				// 		});
				// 	}
				// }else{
				// 	this.$router.push('/invest');
				// }
			},
			start() {
				Fetch("/user/basicinfo").then((r) => {
					this.data = r.data;
					this.tong = r.data.tong;
					this.vip = r.data.vip;
					this.user = r.data.user;
					this.cashes = r.data.cashes;
					this.vips = r.data.vips;
					this.money = (r.data.user.money-r.data.orderprice).toFixed(0);
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 44px;
		// background: url(../images/user/tg_bg.png) no-repeat center center;
		background-size: 100% 100%;
		position: relative;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
		
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    color: #FFFFFF;
		    margin-top: 20px;
		
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    color: rgba(255, 255, 255, 0.8);
		    text-align: left;
		    margin: 3px auto 0 auto;
			margin-left: 15%;
		}
	}
	.user_top{
		width: 96%;
		position: relative;
		background: #f1bb0e;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		padding-bottom: 5px;
		color: #FFF;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 80px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			p:nth-child(1){
				font-size: 4.5vw;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #FF0000;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #FF0000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-top: -70px;
		width: 88%;
		margin-left: 6%;
		p{
			width: 28%;
			padding: 5px;
			border-radius: 5px;
		}
		.active{
			background: #f61a44;
			color: #FFFFFF;
		}
	}
	.list{
		margin-top: 10px;
		width: 96%;
		margin-left: 2%;
		background: #FFFFFF;
		border-radius: 5px;
		.item {
		    height: 52px;
		    line-height: 52px;
		    width: 314px;
		    margin: 0 auto;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    border-bottom: 1px solid #E3E4E5;
			p:nth-child(1){
		        font-size: 13px;
		        color: #000;
		        margin-left: 8px;
		    }
			p:nth-child(2){
		        flex: 1;
		        margin-left: auto;
		        text-align: right;
		        font-size: 12px;
		        color: rgba(0, 0, 0, 0.4);
		    }
		}
	}
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 12px;
			width: 90%;
	    }
	}
	.nopermit{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin: 3vw auto;
		p{
			display: flex;
			a{
				text-decoration: none;
				width: 100%;
				text-align: center;
				.basic_btn{
					width: 80%;
					margin: 0 auto;
					height: 12vw;
					font-size: 1.3em;
					line-height: 12vw;
				}
			}
		}
	}
	.scrollBox {
		width: 96%;
		margin-left: 2%;
		position: relative;
	}
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #000;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ebedf0;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.table-wrap {
	    position: relative;
	    overflow: hidden;
		margin: 10px;
		border-radius: 10px;
	}
	.ui-table {
	    margin-bottom: -1px;
	    background: #fff7f1;
	}
	.ui-table {
	    background: #fff;
	    font-size: 12px;
	}
	.ui-table {
	    width: 100%;
	    border-collapse: collapse;
	    border-spacing: 0;
	    text-align: center;
		th {
		    height: 40px;
		    background: #ffeee2;
		    font-size: 14px;
		    color: #6c3b23;
		    text-align: center;
			font-weight: 400;
		}
		 .pl {
		    padding-left: 15px;
		}
		td {
		    height: 40px;
		    color: #6d6d6d;
		    border-bottom: 1px solid #ffe8de;
		    text-align: center;
		}
	}
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 2vw 3vw;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 20vw;
	    height: 20vw;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 45%;
		max-width: 200px;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 3.8vw;
	    font-weight: bold;
	    color: #222;
		margin-bottom: 1vw;
		margin-top: 8%;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 3vw;
		font-weight: bold;
		color: #999;
		line-height: 1.5em;
	}
	.vip-item .action-box .ord{
		font-size: 2vw;
		font-weight: bold;
		line-height: 6vw;
		color: rgb(74, 193, 171);
	}
	.vip-item .action-box .i-icon {
	    padding: 2vw 3vw;
	    text-align: center;
	    background-color: #f1bb0e;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 1.5em;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #f1bb0e;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 50%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	
	.stat {
	    width: 100%;
	    padding:  0;
		color: #FFF;
		.item {
		    display: flex;
		    flex-direction: row;
		    justify-content: flex-start;
		    margin: 0 ;
			.item-left {
			    flex: 1;
			    margin: 2vw;
			    border-radius: 2vw;
			    padding: 2vw;
			    text-align: center;
			    background-color:#f1bb0e;
				color: #000;
				.title {
				    line-height: 20px;
					font-size: 12px;
					font-weight: 500;
				}
				.value {
				    line-height: 40px;
				    font-size: 24px;
				    font-weight: bold;
				}
			}
		}
	}
	.basic_btn{
		margin: 0 auto;
	}
	/deep/ .van-circle__text{
		color: #FFF;
	}
	.wrapper1 {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	  }
	
	.block {
	    width: 120px;
	    height: 120px;
	}
	.user_money{
		display: block;
	    width: 90%;
	    margin-left: 5%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 2vh;
	    background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
		    margin-bottom: 4%;
			>div:first-child {
			    display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
				box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			}
		}
	}
	
	.capital_title{
		width: 90%;
		height: auto;
		padding: 10px;
		margin: 3% 5%;
		border-radius: 10px;
		background-color: #191919;
		color: #FFFFFF;
		.capital_text{
		    width: 100%;
		    display: flex;
		    justify-content: space-around;
		    flex-direction: column;
		    // border-bottom: 1px solid #232f3e;
			font-size: 1.3em;
			line-height: 1.5em;
			p {
			   font-size: 0.9em;
			   margin: 3% 0;
			   line-height: 1.5em;
			}
		}
		.capital_fun{
		    width: 100%;
		    height: 90px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
			>div{
			    width: 50%;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			    flex-direction: column;
				font-size: 1.1em;
				line-height: 2.3em;
				>p:last-child {
				    color: #FFF;
				    font-size: 19px;
				    font-weight: 700;
				}
			}
			>div:first-child {
			    border-right: 1px solid #fff;
			}
		}
		.capital_result{
		    width: 100%;
		    margin: 5% 0;
		    font-size: 15px;
			>div{
			    display: flex;
			    align-items: center;
				>p:last-child {
				    margin-left: 2%;
				}
			}
			img{
			    width: 30px;
			    height: 30px;
				display: inline-block;
				overflow: hidden;
				position: relative;
			}
		}
	}
	.order_list1{
	    background-color: #fff;
	    padding: 10px;
		margin: 10px;
	    border-radius: 10px;
	    box-shadow: 0 4px 4px rgba(0,0,0,.05);
		.list_top1{
		    width: 100%;
		    height: 90%;
		    border-bottom: 1px dashed gray;
		    display: flex;
		    justify-content: space-between;
		    padding: 5px 0;
			background: #f2f2f2;
			padding: 10px;
			border-radius: 5px;
			img{
			    max-width: 100px;
			    max-height: 100px;
			    border-radius: 10px;
			}
			.list_text1{
			    display: flex;
			    justify-content: space-between;
			    flex-direction: column;
				padding-left: 10px;
				font-weight: bold;
				> span:first-child {
				    display: block;
				    font-size: 12px;
				    color: #37475a;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    -webkit-line-clamp: 4;
				    display: -webkit-box;
				    -webkit-box-orient: vertical;
					line-height: 1.5em;
				}
				 > div {
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    margin: 3% 0;
				    color: #232f3e;
				    font-size: 17px;
				    font-weight: 600;
					> p:last-child {
					    color: #034aff;
					    font-size: 12px;
					}
				}
			}
		}
		.list_down{
		    /* height: 50%; */
		    display: flex;
		    flex-direction: column;
		    justify-content: space-between;
		    font-size: 13px;
		    padding: 5px 0;
			line-height: 32px;
			> div{
			    display: flex;
			    justify-content: space-between;
			    align-items: center;
			    color: #37475a;
			    // height: 20px;
				> span:last-child {
				    color: #232f3e;
				    font-size: 13px;
				}
			}
		}
		.list_down1{
		    height: auto;
		    text-align: end;
			font-size: 16px;
		}
	}
	.basic_btn{
		margin: 5% auto;
	}
	
	.pop_box{
	    width: 90%;
	    max-width: 600px;
	    padding: 5px;
	    position: relative;
	    border-radius: 10px;
	    background-image: linear-gradient(#fca120,#fff);
		.pop_but{
		    width: 96%;
		    margin: 4% 2%;
		    height: 41px;
		    border-radius: 10px;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    background-color: #232f3e;
		    color: #ffcd00;
			font-size: 1.3em;
		}
		.capital_evaluate{
			width: 100%;
			height: auto;
			padding: 10px;
			font-size: 1.3em;
			>span{
				margin-right: 3vw;
			}
		}
		.second{
		    background-color: #d9d9d9;
		    color: #37475a;
		}
	}
	.wrapper {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    margin-top: 15vh;
	}
	
	/deep/ .van-overlay{
		position: absolute;
	}
	.basic_wrap{
		position: relative;
		padding-bottom: 100px;
		height: 100vh;
	}
	.top{
		margin: 0;
		margin-bottom: 0;
	    border-radius: 8px;
	    // background-color: #fff;
		.shop{
		    background: linear-gradient(135deg, #4b60b3 0%, #f1bb0e 100%);
		    border-radius: 8px 8px 0 0;
		    color: #fff;
		    padding: 15px;
			.shop-name  {
				.van-col:first-child{
					font-size: 16px;
					font-weight: 500;
					line-height: 20px;
					
				}
				.van-col:last-child {
				    opacity: .7;
				    font-size: 12px;
					line-height: 16px;
				}
			}
		}
		.balance>.van-row{
		    border-bottom: 1px solid #dee2e6;
		}
		.van-row:first-child {
		    flex-wrap: nowrap;
		}
		.current .van-col:first-child{
			font-size: 30px;
			font-weight: 300;
			color: #fff;
			line-height: 35px;
		}
		.balance>.van-row:first-child {
		    flex-wrap: nowrap;
		    padding: 15px;
		}
		.other .van-col div:first-child {
		    font-weight: 300;
		    font-size: 14px;
			color: #000;
		}
		.balance .other,.grab-button{
		    padding: 15px;
		}
		.balance .other .van-col:last-child {
		    text-align: right;
		}
		.grab-button .van-button--primary{
		    background-color: #f1bb0e;
		    border-color: #f1bb0e;
			border-radius: 30px !important;
		}
		.current .van-col:last-child{
			opacity: .7;
			font-size: 12px;
		}
		.balance>.van-row:first-child .van-button--primary{
		    background-color: #f1bb0e;
		    border-color: #f1bb0e;
		    padding: 0;
		    width: 44px;
		    font-size: 18px;
		}
		.van-col--24 {
		    width: 100%;
		}
		.van-col {
		    float: left;
		    box-sizing: border-box;
		    min-height: 1px;
			line-height: 20px;
		}
		.shop .van-icon{
		    font-size: 35px;
		    margin-right: 10px;
		}
	}
	.user_top1{
		width: 96%;
		position: relative;
		// background: #3b2f5e;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		margin-top: 10px;
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    text-align: left;
		    margin: 3px 3vw;
			
		}
	}
	
	
	.slot-machine {
	  text-align: center;
	  margin-top: 20px;
	}
	
	.slot {
	  width: 22%;
	  height: 100px;
	  margin: 10px;
	  display: inline-block;
	}
	
	.van-swipe-item {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  font-size: 24px;
	}
.top_header {
		position: relative;
		width: 100%;
		background-size: 100% 100%;
		// background: #f1bb0e;
		.set_go{
			width: 38px;
			height: 38px;
			position: absolute;
			top: 11px;
		}
		
		.set_go {
			right: 14px;
			background: url(../images/user/sign.png) no-repeat center center;
			background-size: 100% 100%;
		}
		.user_detail {
			width: 100%;
			padding: 15px 15px 0 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.user_header {
				width: 60px;
				height: 60px;
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0.3);
				img {
					width: 100%;
					height: 100%;
				}
			}
			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				color: #000;
				.user_all {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.user_nickname {
						line-height: 1.6em;
						font-size: 1.2em;
						margin-left: 1em;
					}
				}
			}
		}
		.user_vip{
			color: #FFFFFF;
			font-weight: bold;
			font-size: 16px;
			margin: 10px 20px 20px 20px;
		}
		.user_balance{
			text-align: center;
			div{
				margin: 10px 0;
			}
			div:nth-child(1){
				font-size: 14px;
				color: #d3d5d6;
			}
			div:nth-child(2){
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}
		}
		.user_money{
			justify-content: space-between;
			text-align: center;
			
		}
	}
	.cards{
		padding: 10px 16px;
		margin: 10px 16px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: #FFF;
		line-height: 20px;
		background: linear-gradient(180deg, #000 0%, #000 100%);
		.flex-e-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-end;
		}
		.top {
		    margin-bottom: 8px;
		}
		
		.top div {
		    font-weight: 700;
			font-size: 15px;
			line-height: 25px;
		}
		
		.top .top-left>div:last-child {
		    word-break: break-all;
		    font-style: italic;
		    font-size:26px;
			    
		}
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		}
		.top .top-left>div:last-child span {
		    font-style: normal;
		    font-size: 12px;
			font-weight: 400;
		}
		
		.top .top-right {
		    text-align: center
		}
		
		.top .top-right .group {
		    background-color: var(--84e63418);
		    color: var(--78b8770c);
		    padding: 2px 5px;
		    font-size: 12px;
		    flex-shrink: 0
		}
		
		.top .top-right .group img {
		    margin-right:4px
		}
		
		.top .top-right>div:first-child {
		    margin-bottom: 8px
		}
		
		.top .top-right div {
		    background-color: #fff;
		    padding: 2px 8px;
		    color: #000;
		    border-radius: 8px
		}
		
		.middle {
		    display: flex;
		    align-items: center
		}
		
		.middle span:first-child {
		    margin-right: 10px;
		}
		
		.middle span {
		    display: inline-block;
		    font-size: 12px;
		    padding: 2px 5px;
		    text-align: center;
		    color: #FFF;
		    border: 1px solid #FFF;
		    border-radius: 4px;
			line-height: 20px;
		}
		
		.mActive {
		    background-color: #F1BB0E;
		    color: #000!important;
		    border: none!important
		}
		
		.bottom {
		    margin-top: 8px
		}
		
		.bottom .bottom-left .left-item:not(:last-child) {
		    border-right: 1px solid #F1BB0E
		}
		
		.bottom .bottom-left .left-item:last-child {
		    margin-right: 0
		}
		
		.bottom .bottom-left .left-item {
		    display: flex;
		    flex-direction: column;
		    align-items: start;
		    justify-content: center;
		    margin-right: 10px;
		    padding-right: 10px;
		    font-size: 16px
		}
		
		.bottom .bottom-left .left-item div {
		    color: var(--40ca1237)
		}
		
		.bottom .bottom-left .left-item div:first-child {
		    opacity: .8;
		    font-size: 12px
		}
		
		.bottom .bottom-left .left-item div:last-child {
		    font-weight: 600;
		    word-break: break-all
		}
	}
	.con {
	    width: 100%;
	    background-color: #fff;
		padding-bottom: 100px;
		.charts {
		    padding: 16px 16px 0;
		    box-sizing: border-box;
		}
		
		.charts .charts-left {
		    min-height: 170px;
		    display: flex;
		    flex-direction: column;
		    align-items: center;
		    justify-content: space-between;
		    box-sizing: border-box
		}
		
		.charts .charts-left .left-top,.charts .charts-left .left-bottom {
		    position: relative;
		    min-width: 135px;
		    max-width: 135px;
		    box-sizing: border-box;
		    border: 1px solid #F1BB0E;
		    border-radius: 12px;
		    padding: 9px 8px
		}
		
		.charts .charts-left .left-top .char1,.charts .charts-left .left-bottom .char1 {
		    position: absolute;
		    right: 16px;
		    bottom: 8px;
		    height: 100%
		}
		
		.charts .charts-left .left-top div:nth-child(1),.charts .charts-left .left-bottom div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-top div:nth-child(2),.charts .charts-left .left-bottom div:nth-child(2) {
		    margin-top: -4px;
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-left .left-top div:nth-child(3),.charts .charts-left .left-bottom div:nth-child(3) {
		    margin-top: -4px;
		    font-size: 10px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-bottom img {
		    position: absolute;
		    right: 0;
		    z-index: 99;
		    width: 37px;
		    height: 16px;
		    top: 50px;
		    left: 60px
		}
		
		.charts .charts-left .left-bottom div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1 {
		    margin: 0 6px
		}
		
		.charts .charts-right2 div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1,.charts .charts-right2 {
		    flex: 1;
		    position: relative;
		    box-sizing: border-box;
		    min-width: 96px;
		    max-width:112px;
		    min-height: 170px;
		    border: 1px solid #F1BB0E;
		    padding: 6px 6px 0;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 div:nth-child(1),.charts .charts-right2 div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-right1 div:nth-child(2),.charts .charts-right2 div:nth-child(2) {
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-right1 div:nth-child(3),.charts .charts-right2 div:nth-child(3) {
		    font-size: 10px;
			line-height: 19px;
			word-break: auto-phrase;
		}
		
		.charts .charts-right1 .char,.charts .charts-right2 .char {
		    position: absolute;
		    bottom: 0;
		    left: -1px;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 img,.charts .charts-right2 img {
		    width: 100%;
		    position: absolute;
		    left: 0;
		    bottom: 0
		}
		
		.vip-box {
		    width: 100%;
		    padding: 0 16px;
		    box-sizing: border-box
		}
		
		.vip-box .header2 {
		    padding: 12px 0;
		    width: 100%;
			margin-top: 10px;
		}
		
		.vip-box .header2 .label {
		    font-weight: 700;
			font-size: 15px;
		    color: #000;
		}
		
		.vip-box .header2 .more {
		    width: 65%
		}
		
		.vip-box .header2 .more .text {
		    font-weight: 700
		}
		
		.vip-box .header2 .more .img {
		    width: 14px;
		    height:14px;
		    margin-left: 3px
		}
		
		.vip-box .svip {
		    background: #F1BB0E;
		    border-radius: 4px;
		    padding: 0 8px;
		    height: 65px;
		    color: #000;
		}
		
		.vip-box .svip span,.vip-box .svip i {
		    font-weight: 700;
		    margin-left: 8px
		}
		
		.vip-box .svip img {
		    width: 36px;
		    height: 36px
		}
		
		.notice-swipe {
		    height: 28px
		}
		
		.notice-swipe .notice-swipe-item {
		    height: 28px;
		    line-height: 28px
		}
		.VipLevel {
		    width: 100%;
		    height:40px;
		    background: #F1BB0E;
		    border-radius: 8px;
		    padding: 0 10px;
		    color: #000
		}
		
		.VipLevel .left .level {
		    font-size: 14px;
		    font-weight: 700;
		    margin-left:10px
		}
		
		.VipLevel .right .clickToEnte {
		    font-size: 12px;
		    font-weight: 700
		}
		.flex-b-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-start;
		}
		
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center
		}
		.flex-c-c {
		    display: flex;
		    justify-content: center;
		    align-items: center;
		}
		.cardd {
		    width: 90%;
		    margin: 10px auto;
		    .cardd-item {
		        height: 45px;
		        width: 45%;
		        padding: 10px 8px;
		        background-color: #f6f7f9;
		        border-radius: 8px;
		        flex-shrink: 0;
		    }
		
		    .cardd-item img {
		        width: 24px;
		        height: 24px;
		    }
		
		    .cardd-item span {
		        font-size: 12px;
		        font-weight: 700;
		        margin-left: 5px;
		        line-height: 14px;
		    }
		
		    .cardd-item:not(:last-child) {
		        margin-right: 8px;
		    }
		
		    .cardd-item:last-child {
		        flex: 1;
		    }
		}
		.start-box{
		    background-color: #000;
		    width: 92%;
		    border-radius:12px;
		    margin: 12px auto 0;
		    overflow: hidden;
			text-align: center;
			img{
				height: 220px;
				border-radius: 16px;
				overflow: hidden;
			}
		}
		.btn-box{
			width: 90%;
			margin: 16px auto;
			text-align: center;
			button{
				color: white;
				background: #000;
				border-color: #000;
				width: 100%;
				line-height: 45px;
				border-radius: 5px;
				font-weight: bold;
				font-size: 14px;
			}
		}
	}
</style>
